import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminReports = lazy(() => import("@/pages/admin/AdminReports"));

export const Route = createFileRoute("/admin/rapporter")({
  component: () => <AdminReports />,
});
